export default __webpack_public_path__ + "static/footer_cv-7f8c1f14fc229dde1e15a56bb6035d52.png";